import { api } from "@/lib/api";

export const formatBRL = (v) => new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(v || 0);

export const BILLING_LABELS = { trial: "Período grátis", active: "Ativa", past_due: "Pagamento pendente", canceled: "Cancelada", liberado: "Liberada pela plataforma" };

export const startCheckout = async () => {
  const { data } = await api.post("/billing/checkout", { origin_url: window.location.origin });
  window.location.href = data.checkout_url;
};

export const startPix = async () => {
  const { data } = await api.post("/billing/pix", { origin_url: window.location.origin });
  window.location.href = data.checkout_url;
};

export const openPortal = async () => {
  const { data } = await api.post("/billing/portal", { origin_url: window.location.origin });
  window.location.href = data.url;
};

export const whatsappLink = (digits, text) => {
  const d = (digits || "").replace(/\D/g, "");
  const full = d.length <= 11 ? `55${d}` : d;
  return `https://wa.me/${full}?text=${encodeURIComponent(text)}`;
};
